export default "__VITE_ASSET__6bh2mU93__"